import script from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"

import "./ExportJSON.vue?vue&type=style&index=0&id=722be52d&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722be52d"]])

export default __exports__